module.exports = __webpack_public_path__ + "static/media/talent-donation-love-small.2bc35886.svg";